/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'
import { useForm } from "react-hook-form"

import Menu from '../../../components/CustomerClub/Menu'

import cashIcon from '../../../assets/svg/Cash.svg'
import { get, post } from '../../../services/http'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

function index() {
  document.title = 'تنظیمات کش بک'

  const [percent, setPercent] = useState(0)
  const [percentId, setPercentId] = useState(0)
  const [clickButton, setClickButton] = useState(false)

  const { register, handleSubmit } = useForm()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/cashback?token=${token}`).then(response => {
      setPercent(response.data.data[0].percent)
      setPercentId(response.data.data[0]._id)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }, [token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    post(`/api/admin/cashback?token=${token}`, {
      percent: data.percent,
      id: percentId
    }).then(response => {
      console.log(response.data.success)
      if (response.data.success) {
        setClickButton(true)
        notify('success', 'کش بک با موفقیت آپدیت شد')
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      }
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'cashback'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={cashIcon} alt='cashIcon' />
              </div>
              <div className='text'>
                ‌‌کش بک
              </div>
            </div>
            <div className="left">
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * میخواید به ازای هر سفارش به مشتری چقدر کش بک (اعتبار هدیه) بدید تا توی خرید بعدیش استفاده کنه؟
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات کش بک
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeName'>درصد کش بک : ({percent}) درصد * :</label>
                <input id='offCodeName' {...register("percent", { required: true, minLength: 1 })} className='ltrdirection' type='number' placeholder='5..' />
                <small id='offCodeNameAlert'>کش بک باید وارد شود</small>
              </div>
            </div>
            <button className='createButton' style={clickButton ? { backgroundColor: 'gray' } : {}}>{clickButton ? 'لطفاً صبر کنید ...' : 'ایجاد تغییرات'}</button>
          </form>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index